import { ManagedPageTitleOptions, useManagedPageTitle } from "app/providers/PageTitleProvider";

export function usePageTitle(customText?: string, options: Omit<ManagedPageTitleOptions, "title"> = {}) {
    useManagedPageTitle({
        ...options,
        title: customText,
        enabled: options.enabled ?? Boolean(customText?.trim()),
    });
};
